<template>
  <Layout>
    <q-card class="flexbox">
      <div class="profile-header">
        <div class="profile-header-title">Social Accounts</div>
      </div>
      <div class="profile-content">
        <loading v-if="isLoading" id="loading"></loading>
        <div class="full-width" v-else>
          <div class="row full-width" v-if="Object.keys(providers).length > 0">
            <div class="col col-xs-12 col-sm-6 col-md-4 item text-center" v-if="'google' in providers">
              <div>
                <h3 class="text-h6">
                  <i class="fab fa-google"></i>
                  Google
                </h3>
                <q-btn :color="hasAccount('google') ? 'red' : 'green'" outline @click="linkAccount('google')">
                  <template v-slot:default>
                    <i class="fas fa-link" style="margin-right: 5px;"></i>
                    {{ hasAccount('google') ? 'Unlink' : 'Link' }}
                  </template>
                </q-btn>
              </div>
            </div>
            <div class="col col-xs-12 col-sm-6 col-md-4 item text-center" v-if="'facebook' in providers">
              <div>
                <h3 class="text-h6">
                  <i class="fab fa-facebook"></i>
                  Facebook
                </h3>
                <q-btn :color="hasAccount('facebook') ? 'red' : 'green'" outline @click="linkAccount('facebook')">
                  <template v-slot:default>
                    <i class="fas fa-link" style="margin-right: 5px;"></i>
                    {{ hasAccount('facebook') ? 'Unlink' : 'Link' }}
                  </template>
                </q-btn>
              </div>
            </div>
            <div class="col col-xs-12 col-sm-6 col-md-4 item text-center" v-if="'linkedin' in providers">
              <div>
                <h3 class="text-h6">
                  <i class="fab fa-linkedin"></i>
                  LinkedIn
                </h3>
                <q-btn :color="hasAccount('facebook') ? 'red' : 'green'" outline @click="linkAccount('linkedin')">
                  <template v-slot:default>
                    <i class="fas fa-link" style="margin-right: 5px;"></i>
                    {{ hasAccount('linkedin') ? 'Unlink' : 'Link' }}
                  </template>
                </q-btn>
              </div>
            </div>
          </div>
          <div v-else>
            <p class="text-center">No social account is available to link.</p>
          </div>
        </div>
      </div>
    </q-card>
    <q-dialog v-model="dialog" persistent>
      <q-card>
        <q-card-section class="row items-center">
          <span class="q-ml-sm">
            The link between your account and the selected service will be removed, are you sure?
          </span>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Cancel" color="primary" v-close-popup/>
          <q-btn flat label="Yes" color="negative" @click="unlinkAccount"/>
        </q-card-actions>
      </q-card>
    </q-dialog>
  </Layout>
</template>

<script>
import axios from "../axios";
import Layout from "../components/Layout";
import Loading from "@/components/Loading.vue";

export default {
  name: "social-accounts",
  components: {
    Layout,
    Loading
  },
  data() {
    return {
      user: null,
      providers: {},
      dialog: false,
      unlinkAccountType: null,
      isLoading: false
    }
  },
  async mounted() {
    try {
      this.isLoading = true;
      const {data: meData} = await axios.get('/me');
      this.user = meData.data;
      const {data} = await axios.get(`/auth/oauth2?redirect_path=${this.$route.path}`);
      this.providers = data.data;
    } catch (error) {
      console.error(error);
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    async linkAccount(service) {
      if (this.hasAccount(service)) {
        this.dialog = true;
        this.unlinkAccountType = service;
        return;
      }
      const serviceUrl = this.providers[service] || null;
      if (serviceUrl) {
        window.location.href = serviceUrl;
      }
    },
    async unlinkAccount() {
      try {
        this.isLoading = true;
        await axios.delete(`/unlink-social-account/${this.unlinkAccountType}`);
        this.user.socials = this.user.socials.filter(social => social.provider !== this.unlinkAccountType);
        this.dialog = false;
      } catch (error) {
        console.error(error);

        this.$q.notify({
          message: error.response.data.message,
          timeout: 2000,
          position: 'top-right',
          progress: true,
          type: 'negative'
        });
      } finally {
        this.dialog = false;
        this.isLoading = false;
      }
    },
    hasAccount(service) {
      return this.user.socials.some(social => social.provider === service);
    }
  },
  metaInfo() {
    return {
      title: `Social Accounts - FMS`,
      meta: [
        {
          name: "description",
          content: "",
        },
        {
          property: "og:title",
          content: "Settings - FMS",
        },
        {property: "og:site_name", content: "FMS"},
        {property: "og:type", content: "website"},
        {name: "robots", content: "index,follow"},
      ],
    };
  },
};
</script>

<style scoped>
.special-component {
  width: 100%;
  background-color: #fff;
}

.item {
  padding: 10px;

  > div {
    padding: 10px 10px 30px;
    border: 1px solid #e0e0e0;
    border-radius: 5px;
  }
}
</style>
